import React, { useState } from "react";
import { IonCol, IonIcon, IonImg, IonLabel, isPlatform } from "@ionic/react";
import { chevronDownOutline } from "ionicons/icons";
import { getFaqs } from "../../../Store/Actions";
import * as constants from "../../../constants";
import { checkMediaQuery } from "../../../utils";
import { AlertMessage } from "../../../utils/alertMessage";
import { hideMessenger, openIntercomMessanger } from "../../../intercom";
import { connect } from "react-redux";

const HelpAndSupport: React.FC = (props: any) => {
  const [faqs, setFaqs] = useState([]);
  const [selectedFaqIds, setselectedFaqIds] = useState<any>([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const response = await props.getFaqs("settings");
      if (response && response.status === "SUCCESS") {
        setFaqs(response.data);
      }
    };
    fetchData();
  }, []);
  const [showCallusPopup, setshowCallusPopup] = useState(false);
  const handleCallUs = () => {
    if (isPlatform("desktop")) {
      setshowCallusPopup(true);
    } else {
      document.location.href = `tel:${constants.CONTACT_US_MOBILE}`;
    }
  };
  return (
    <>
      <IonCol className="middle_panle res_bg_color" size-md="6">
        <div
          className={
            isPlatform("mobile") ? "mobile-layout-main-div wholeApp" : "mobile-layout-main-div"
          }
          style={{ paddingTop: isPlatform("android") ? 20 : 0 }}
        >
          <div className="page-heading-div">
            <IonImg
              src={checkMediaQuery() ? "/images/gray_backarrow.svg" : "/images/back_arrow.svg"}
              className="back_arrow"
              onClick={() => props.history.goBack()}
            />

            <IonLabel className="personal_details_labels" color="secondary">
              {constants.HELP_AND_SUPPORT}
            </IonLabel>
          </div>
        </div>
        <div className="FAQs-div">
          <div className="FAQs-content">
            <IonLabel color="tertiary" className="FAQs-heading ">
              {constants.FAQs}
            </IonLabel>
            {!!faqs.length &&
              faqs.map((qns: any, faqInd: any) => (
                <div
                  className="sd_faq_parent"
                  onClick={() => {
                    if (!selectedFaqIds.includes(qns.faqId)) {
                      setselectedFaqIds([qns.faqId]);
                    } else {
                      setselectedFaqIds([]);
                    }
                  }}
                  key={faqInd}
                >
                  <div className="sd_sub_parent">
                    <IonLabel className="sd_faq_text">{qns.question}</IonLabel>
                    <IonImg
                      className={selectedFaqIds.includes(qns.faqId) ? "up_arrow" : "down_arrow"}
                      src={
                        selectedFaqIds.includes(qns.faqId)
                          ? "images/download_arrow.svg"
                          : "images/download_arrow.svg"
                      }
                    />
                  </div>
                  {selectedFaqIds.includes(qns.faqId) && (
                    <div className="sd_faq_text sd_margintop_ten">
                      <IonLabel className="sd_faq_text">{qns.answer}</IonLabel>
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
        {/* ! uncomment below for contact us */}
        {/* <div className="FAQs-div">
          <div className="FAQs-content">
            <IonLabel color="tertiary" className="FAQs-heading">
              {constants.CONTACT_US}
            </IonLabel>
            <div
              className="contact-us-div"
              onClick={() => openIntercomMessanger()}
            >
              <IonLabel color="light" className="contact-us">
                {constants.CHAT_WITH_US}
              </IonLabel>
              <IonImg src="/images/chatWithUs.svg" />
            </div>
            <div
              className="call-us-div"
              onClick={() => {
                handleCallUs();
                hideMessenger();
              }}
            >
              <IonLabel color="light" className="FAQ-question">
                {constants.CALL_US}
              </IonLabel>
              <IonImg src="/images/Vector.svg" />
            </div>
          </div>
        </div> */}
        <AlertMessage
          showAlert={showCallusPopup}
          alertMessage={"Please react out to us at +91 9848012345 "}
          onDidDismiss={() => {
            setshowCallusPopup(false);
          }}
          alertHeader={"Call Us"}
          hideActionBtns={true}
          actionItemForAlert={() => {
            setshowCallusPopup(false);
          }}
        />
      </IonCol>
    </>
  );
};
export default connect(null, { getFaqs })(HelpAndSupport);
